import { types } from "@vilocnv/allsetra-core";
import { mapObjectToMarker } from "./map-object-to-marker.mapper";

export function mapObjectsToMarkers(
  objects: types.IObject[] | undefined
): types.MarkerType[] {
  if (!objects) return [];
  return (
    objects
      ?.map(mapObjectToMarker)
      ?.filter((marker): marker is types.MarkerType => !!marker) ?? []
  );
}
